module.exports = __webpack_public_path__ + "public/img/logo.a3e6ee33.png";